module.exports = __webpack_public_path__ + "img/Nautica-G.0adf6ff5.jpg";